/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect } from 'react';
import { useSearchParam } from 'react-use';
import { Social } from 'utils/enum';
import { setShareProviderCookie } from 'utils/shareCookie.util';

export const SharePostTiktok = () => {
  const code = useSearchParam('code');
  const provider = Social.TIKTOK;

  useEffect(() => {
    handleGetAccessToken();
  });

  const handleGetAccessToken = async () => {
    window.document.cookie = `access_token=${code};domain=.${window.location.host}; path=/`;
    window.document.cookie = `state=true;domain=.${window.location.host}; path=/`;
    setShareProviderCookie(provider);
    window.close();
  };

  return (
    <div className="App">
      <header className="App-header"></header>
    </div>
  );
};
